import React from 'react'

const DashboardPage: React.FC = () => {
  return (
    <div className="space-y-6">
      <div>
        <p className="text-muted-foreground">Welcome to Control Tower Operations</p>
      </div>
      
     
    </div>
  )
}

export default DashboardPage

